import { useState, useEffect } from "react";

import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";

import Nav from "../Nav";

import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";

const Links = () => {
	const [user, setUser] = useState({});
	const [result, setResult] = useState({});
	const [status, setStatus] = useState(10);
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	/* statutes
		0 = sponsorId not in registrations
		1 = sponsorId found in registrations, submitted
		2 = sponsorId found in registrations, not submitted
		3 = output link to screen
		10 = idle
	*/

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/snapshotInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleStatus = (result) => {
		setResult({ ...result });
		setStatus(result.status);
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Registration Links" admin={true} />

						<p>
							Use this form to generate registration links for BFC sponsor
							invites.
						</p>

						<div className="spacer"></div>

						{status === 10 ? (
							<Form1 handleStatus={handleStatus} />
						) : status === 3 ? (
							<Form3 result={result} handleStatus={handleStatus} />
						) : (
							<Form2 result={result} handleStatus={handleStatus} />
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={9} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Links;
